// extracted by mini-css-extract-plugin
export default {"contactList":"ContactList_contactList__xuvi-","unsubscribed":"ContactList_unsubscribed__ODUff"};